<template>
    <ModalBase
        name="add-miembro-familia"
        title="Añadir miembro"
        width="500"
        @close="cancel"
    >
        <div class="tw:flex tw:flex-col tw:gap-3">
            <div class="tw:flex tw:items-start tw:gap-3">
                <div class="tw:flex-1">
                    <BaseInputText
                        label="Nº abonado"
                        name="numero_abonado"
                        :value="numeroAbonado"
                        placeholder="Nº abonado"
                        @input="numeroAbonado = $event"
                    />
                </div>
                <div class="tw:flex-1">
                    <BaseInputText
                        label="DNI"
                        name="dni"
                        :value="dni"
                        placeholder="DNI"
                        @input="dni = $event"
                    />
                </div>
            </div>
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" @click="cancel">Cancelar</Button>
                <Button
                    variant="primary"
                    :disabled="!numeroAbonado.trim() || !dni.trim()"
                    @click="submit"
                >
                    Añadir
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const emit = defineEmits(['add-member', 'close'])
    const instance = getCurrentInstance()

    const numeroAbonado = ref('')
    const dni = ref('')

    function cancel() {
        instance.proxy.$modal.hide('add-miembro-familia')
        emit('close')
    }

    function submit() {
        if (!numeroAbonado.value.trim() || !dni.value.trim()) return

        emit('add-member', {
            numero_abonado: numeroAbonado.value.trim(),
            dni: dni.value.trim()
        })

        instance.proxy.$modal.hide('add-miembro-familia')
        emit('close')
    }
</script>
